/* eslint-disable array-callback-return */
import moment from 'moment';
import { parseDateUtc, trimmedDateAt } from '../../../utils/dates';
import globals from '../../../globals/communityGlobals';
import { VisitType } from '../../../enums/assignmentVisitState';

const distinct = items => items.filter((value, index, instances) => instances.indexOf(value) === index);

export const disableButton = treatmentInstances => {
  const dateAt = treatmentInstances[0].selectedDate;
  const today = moment(globals.now).startOf('day');
  const isBehindNow = parseDateUtc(trimmedDateAt(dateAt)).isBefore(parseDateUtc(today));

  return isBehindNow || treatmentInstances.length < 2 || treatmentInstances.length > 5;
};

export const disableBundleVisitButton = treatmentInstances => {
  const isBundled = treatmentInstances.filter(x => x.isBundled);
  const isDisabled = disableButton(treatmentInstances);

  if (
    isDisabled ||
    isBundled.length > 0 ||
    treatmentInstances.some(x => x.visitType === VisitType.PhoneCall || x.masterId !== null)
  ) {
    return true;
  }

  const nhsNumbers = treatmentInstances.map(x => x.nhsNumber);
  const treatmentPostcodes = treatmentInstances.map(x => x.treatmentPostcode);
  const treatmentIds = treatmentInstances.map(x => x.treatmentId);

  if (
    distinct(nhsNumbers).length !== 1 ||
    distinct(treatmentPostcodes).length !== 1 ||
    distinct(treatmentIds).length !== treatmentInstances.length
  ) {
    return true;
  }

  return false;
};

export const disableAssignVisitButton = treatmentInstances => {
  const treatmentIds = treatmentInstances.map(x => x.treatmentId);
  return disableButton(treatmentInstances) || distinct(treatmentIds).length !== treatmentInstances.length;
};

export const disableWhenAnyStatementIsTrue = (...statements) => {
  if (statements && statements.length > 0) {
    return statements.some(statement => statement === true);
  }

  return false;
};
